require('croppie');
document.addEventListener("DOMContentLoaded", function(){
    var mobile = document.querySelector("#mobile_input");
    if(mobile !== null){
        mobile_input = window.intlTelInput(mobile,{
            utilsScript: '/intl-tel-input-16.0.0/build/js/utils.js',
            separateDialCode: true
        });
    }
    $('#enable_sms').click(function(e){
        if($('#enable_sms').is(':checked')){
            $('#mobile_input').attr('required','required');
            $('#mobile_input_required').removeClass('d-none');
        }else{
            $('#mobile_input').removeAttr('required');
            $('#mobile_input_required').addClass('d-none');
        }
    });
    let form = document.getElementById('recruitmentForm');
    let headshotForm = new FormData();
    form.addEventListener('submit',function(evt){
        evt.preventDefault();
        if (!form.checkValidity()) {
            form.classList.add('was-validated');
            window.scrollTo(0,0);
            return false;
        }
        let mobile = validateMobile();
        if(!mobile){
            return false;
        }
        document.getElementById('mobile_input').value = mobile_input.getNumber();
        let partner = document.getElementById('partner_slug').value;
        let formData = new FormData(form);
        formData.append('headshot_temp_file',headshotForm.get('headshot_temp_file'));
        sendRequest('POST', '/register/submit',formData,function(err,data){
            if(err){
                let error = JSON.parse(err);
                let err_str = '';
                if(typeof(error.message) == 'object'){
                    for (const [key, value] of Object.entries(error.message)){
                        err_str += value + '<br>';
                    }
                }else{
                    err_str = error.message;
                }
                console.log(err_str);
                document.getElementById('error_block').innerHTML = err_str;
                document.getElementById('error_block').style.display = '';
                location.href = '#error_block';
            }else{
                let response_data = JSON.parse(data);
                window.location =   response_data.redirect;
            }
        });
    });

    var uploadCrop;

    uploadCrop = $('#cropper').croppie({
        viewport: {
            width: 200,
            height: 200,
            type: 'circle',
        },
        boundary: {
            width: 225,
            height: 225
        },
        enableExif: true
    });

    $('#upload_headshot').on('change', function () {
        readFile(this);
        $('#image_upload_modal').modal('show');
    });
    $('#set_upload').on('click', function (ev) {
        uploadCrop.croppie('result', {
            type: 'canvas',
            size: 'viewport'
        }).then(function (resp) {
            document.getElementById('headshot').children[0].setAttribute('src',resp);
            $('#image_upload_modal').modal('hide');
        });
        uploadCrop.croppie('result', {
            type: 'blob',
            size: 'viewport',
            circle: false
        }).then(function (resp) {
            headshotForm.append('headshot_temp_file',resp);
        });
    });

    $('#full_headshot').on('change',function(){
        const the_file = document.getElementById('full_headshot');
        if (the_file.files.length > 0) {
            const fsize = the_file.files.item(0).size;
            const file = Math.round((fsize / (1024*1024)));
            if (file >= 4) {
                alert('WARNING: Maxiumum file size is 4MB. This file is ' +file+ 'MB. Please choose a smaller file.');
                $("#full_headshot").val(null);
            }
        }
    });

    $('#resume_file').on('change',function(){
        const resume_file = document.getElementById('resume_file');
        if(resume_file.files.length > 0){
            const fsize = resume_file.files.item(0).size;
            const file = Math.round((fsize / (1024*1024)));
            if(file >= 4) {
                alert('WARNING: Maximum file size 4MB. This file is ' + file + 'MB. Please choose a smaller file.');
                $('#resume_file').val(null);
            }
        }
    });

    function readFile(input) {
        if (input.files && input.files[0]) {
            var reader = new FileReader();

            reader.onload = function (e) {
                $('.upload-demo').addClass('ready');
                uploadCrop.croppie('bind', {
                    url: e.target.result,
                    zoom: 0
                });
            }

            $('.cr-slider').attr({'min':0.1, 'max':1.25});
            reader.readAsDataURL(input.files[0]);
        }
    }
    function validateMobile(){
        var front_pass = true;
        if($('#enable_sms').is(':checked') || mobile_input.getNumber() !== ''){
            if(!mobile_input.isValidNumber()){
                front_pass = false;
                var phone_errs = ["Invalid number", "Invalid country code", "Too short", "Too long", "Invalid number"];
                var ph_err_num = mobile_input.getValidationError();
                var msg = "You must enter a valid phone number. " + phone_errs[ph_err_num] + '.';
                $('#mobile_input_err').html(msg).css('visibility','visible');
                location.hash = '#mobile_input_label';
            }else{
                $('#mobile_input_err').html('&nbsp;').css('visibility','hidden');
            }
        }
        return front_pass;
    }

    function sendRequest(method, url, data, done){
        var request = new XMLHttpRequest();
        request.open(method,url);
        request.onload = function () {
            if(request.status == 200){
                done(null, request.response);
            }else{
                done(request.response);
            }
        };
        request.onerror = function () {
            done(request.response);
        };
        request.send(data);
    }

});
